<template>
  <div class="enter-customer">
    <el-dialog title="编辑顾客信息" :visible.sync="dialogShow" width="500px">
      <el-form size="small" ref="form" :model="form" label-width="100px" class="dialog-form">
        <el-form-item label="顾客ID" disabled prop="id">
          {{ form.id }}
        </el-form-item>
        <el-form-item label="顾客手机号" disabled prop="mobile">
          {{ form.mobile || '--' }}
        </el-form-item>
        <el-form-item label="顾客所属管家" prop="serviceUserId">
          <el-select v-model="form.serviceUserId" @change="handleServiceUserChange">
            <el-option v-for="item in options" :key="item.id" :label="item.serviceUserName"
              :value="item.serviceUserId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾客所属代理" prop="agentCompanyId">
          <el-select filterable :disabled="disabled" v-model="form.agentCompanyId" @change="handleAgentUserChange">
            <el-option v-for="item in agentOptions" :key="item.id" :label="item.agentCompanyName"
              :value="item.agentCompanyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remake" class="textarea">
          <el-input type="textarea" v-model="form.remake"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handEnterCustomer" :loading="dialogLoading">确 定</el-button>
      </span>
      <!-- <el-date-picker value-format="yyyy-MM-dd" @change="change" v-model="value1" type="week" format="yyyy 第 WW 周"
        placeholder="选择周" :picker-options="{ firstDayOfWeek: 1 }">
      </el-date-picker> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  updateUser,
  list,
  agentCompanylistAll
} from '@/common/api';
export default {
  name: 'EnterPoints',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customerData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      // value1: '',
      form: {
        id: 0, // 顾客id
        mobile: '', // 顾客手机号
        serviceUserId: 0, // 管家id
        serviceUserName: "", // 管家名字
        agentCompanyId: 0,
        agentCompanyName: "",
        remake: '', // 备注
      },
      options: [],
      agentOptions: [],
      dialogLoading: false,
      disabled: false,

    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

  },
  watch: {
    visible(val) {
      if (val && this.customerData) {
        // 弹窗打开时，将 customerData 复制到 form
        this.form = { ...this.customerData };
        if (this.customerData.agentCompanyId) {
          this.disabled = true
        } else {
          this.disabled = false
        }
        this.getManagerList();
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getManagerList() {
      list().then(res => {
        if (res.data.length === 0) {
          this.$message.error('暂无管家信息');
          return;
        }
        this.options = res.data;
      }).catch(() => {
        this.$message.error('获取管家列表失败');
      })
      agentCompanylistAll({
        type: 1,
      }).then(res => {
        this.agentOptions = res.data.map(v => {
          return {
            agentCompanyId: v.id,
            agentCompanyName: v.name,
          }
        });
      }).catch(() => {
        this.$message.error('获取管家列表失败');
      })
    },
    handleServiceUserChange(val) {
      const selectedOption = this.options.find(option => option.serviceUserId === val);
      this.form.serviceUserName = selectedOption ? selectedOption.serviceUserName : '';
    },
    handleAgentUserChange(val) {
      const selectedOption = this.agentOptions.find(option => option.agentCompanyId === val);
      this.form.agentCompanyName = selectedOption ? selectedOption.agentCompanyName : '';
    },
    handEnterCustomer() {
      this.dialogLoading = true;
      updateUser(this.form).then(res => {
        this.dialogShow = false;
        this.$emit('success');
      }).catch(() => {
        this.$message.error('修改失败');
      }).finally(() => {
        this.dialogLoading = false;
      })
    }
  }
}
</script>


<style scoped lang="scss">
.enter-customer {
  ::v-deep .dialog-form {

    .el-select,
    .el-input {
      width: 100%;
    }
  }
}
</style>